module.exports = __webpack_public_path__ + "static/small-9307d25ef01b9609b8c0694d66d4cc4c.jpg";